// extracted by mini-css-extract-plugin
module.exports = {"required":"styles_required__rce_K","label":"styles_label__05iGP"};